// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { Timer } from "./Timer";
import { ConfirmationClass, ConfirmationWindowComponent } from "./WebApp.ConfirmationWindow";
import { SynchronizationState } from "./WebApp.Entity.Store";
import { application } from "./WebApp.Instance";
import { LoadingIndicator } from "./WebApp.LoadingIndicator";
import { createPopUp } from "./WebApp.PopUp";
import { Labels, WebPageComponent, connectClickOutsideListener, removeClickOutsideListener } from "./WebSite.Page.Component";

export class SearchComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.uri = this.element.dataset.Uri;
    this.active = new HtmlClassSwitch(this.element, "Active");
    this.input = new DomQuery(this.element).getDescendant(WithClass("Field")).component;
    this.results = new DomQuery(this.element).getDescendant(WithTagName("UL"));
    this.labels = new Labels(new DomQuery(this.element).getDescendant(WithClass("Labels")));
    this.searchTimer = new Timer(400);
    this.searchResults = new Array();
    this.abortController = null;

    this.loadingCount = 0;
    this.loading = new HtmlClassSwitch(this.element, "Loading");

    this.closeButton = new DomQuery(this.element).getDescendant(WithClass('Close'));

    if (this.closeButton !== null)
      this.closeButton.addEventListener(
        "click",
        (event) => {
          this.close();
        }
      );

    this.loadingIndicator = new LoadingIndicator();
    this.element.childNodes[0].appendChild(this.loadingIndicator.element);

    window.addEventListener(
      "keydown",
      (event) => {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA" && !this.active.getStatus() && event.key === "/") {
          this.open();

          event.preventDefault();
          event.stopPropagation();
        }
      }
    );

    this.element.addEventListener(
      "keydown",
      (event) => {
        if (this.active.getStatus() && event.key === "Escape") {
          this.close();

          event.preventDefault();
          event.stopPropagation();
        }
      }
    );

    this.input.addEventListener(
      "keydown",
      (event) => {
        if (event.key === "ArrowDown" && this.results.childNodes.length > 0) {
          this.focusFirstResult();
          event.preventDefault();
        }
      }
    );

    this.input.addEventListener(
      "input",
      (event) => {
        this.scheduleSearchOperation();
      }
    );
  }

  scheduleSearchOperation() {
    this.searchTimer.kill();
    this.searchTimer.schedule(
      () => {
        this.search(this.input.getValue());
      }
    )
  }

  clear() {
    this.results.innerHTML = "";
    this.searchResults = new Array();
  }

  close() {
    this.input.input.blur();
    this.active.setStatus(false);
    removeClickOutsideListener(this.clickOutsideListener);
  }

  open() {
    this.active.setStatus(true);

    if (this.input.getValue().length === 0)
      this.prepare();

    this.input.focus();
    this.input.input.select();

    this.clickOutsideListener = connectClickOutsideListener(
      this.element.childNodes[0],
      () => {
        this.close();
      }
    );
  }

  prepare() {
    this.clear();
    this.enterSearch();

    application.entityStore.getAll()
      .then((data) => {
        const available = data.filter(element => element.Current !== null);
        this.renderResults("", available);
      })
      .finally(() => {
        this.leaveSearch();
      });
  }

  renderResults(query, results) {
    const groups = new Map();

    for (const result of results) {
      if (!this.searchResults.includes(result.Uri)) {
        if (!groups.has(result.Category)) {
          groups.set(result.Category, new Array());
        }

        const target = groups.get(result.Category);
        target.push(result);
        this.searchResults.push(result.Uri);
      }
    }

    for (const [name, group] of groups) {
      const regularExpression = query.length > 0 ? new RegExp(query, "gi") : null;

      const groupTitle = document.createElement("span");
      groupTitle.classList.add("Title");
      groupTitle.innerHTML = `${name} (${group.length})`

      const groupResults = document.createElement("ul");

      const groupElement = document.createElement("li");
      groupElement.classList.add("Group");
      groupElement.classList.add(group[0].Type);
      groupElement.appendChild(groupTitle);
      groupElement.appendChild(groupResults);

      this.results.appendChild(groupElement);

      for (const result of group) {
        const title = document.createElement("span");
        title.classList.add("Title");
        title.innerHTML = regularExpression ? result.Title.replace(regularExpression, "<strong>$&</strong>") : result.Title;

        let details = null;

        if (result.Details.length > 0) {
          details = document.createElement("span");
          details.classList.add("Details");
          details.innerHTML = regularExpression ? result.Details.replace(regularExpression, "<strong>$&</strong>") : result.Details;
        }

        const uri = document.createElement("span");
        uri.classList.add("Uri");
        uri.innerText = new URL(result.Uri).pathname;

        const resultElement = document.createElement("span");
        resultElement.appendChild(title);

        if (details !== null)
          resultElement.appendChild(details);

        resultElement.appendChild(uri);

        if (result.Class)
          resultElement.classList.add(result.Class);

        const link = document.createElement("a");
        link.appendChild(resultElement);
        link.href = result.Uri;

        link.addEventListener(
          "click",
          (event) => {
            this.close();
          }
        );

        const item = document.createElement("li");
        item.classList.add("Result");
        item.appendChild(link);
        item.tabIndex = "0";

        if (result.State) {
          item.classList.add(SynchronizationState.toText(result.State));

          let statusLabel = null;

          if (result.State === SynchronizationState.Modified)
            statusLabel = this.labels.SynchronizationPending;
          else if (result.State === SynchronizationState.Conflict)
            statusLabel = this.labels.SynchronizationConflict;
          else if (result.State === SynchronizationState.Failed)
            statusLabel = this.labels.SynchronizationFailed;

          if (statusLabel !== null) {
            const status = document.createElement("span");
            status.classList.add("SynchronizationStatus");
            status.textContent = statusLabel.textContent;

            if ((result.State === SynchronizationState.Conflict || result.State === SynchronizationState.Failed) && result.Error) {
              const error = document.createElement("span");
              error.classList.add("SynchronizationError");
              error.textContent = result.Error;

              const popup = createPopUp(error, status, false, status, 400);

              status.classList.add("Expandable");
              status.addEventListener("mouseenter", (event) => { popup.open(); });
              status.addEventListener("mouseleave", (event) => { popup.close(); });
            }

            resultElement.appendChild(status);
          }

          const actions = document.createElement("span");
          actions.classList.add("Actions");

          if (result.State === SynchronizationState.Failed || result.State === SynchronizationState.Conflict) {
            const retryButton = document.createElement("button");
            retryButton.classList.add("Retry");
            retryButton.title = this.labels.Retry.textContent;
            retryButton.addEventListener(
              "click",
              (event) => {
                event.stopPropagation();
                event.preventDefault();

                navigator.serviceWorker.controller?.postMessage({ Action: "RetryEntity", Uri: result.Uri });
                this.search(query);
              }
            );

            actions.appendChild(retryButton);
          }

          const component = new ConfirmationWindowComponent(
            this.labels.DeleteConfirmationMessage,
            this.labels.Confirm,
            this.labels.Cancel,
            () => {
              this.delete(result.Uri);
              this.search(query);
            },
            ConfirmationClass.Delete,
            this.element.childNodes[0]
          );

          const deleteButton = document.createElement("button");
          deleteButton.classList.add("Delete");
          deleteButton.addEventListener(
            "click",
            (event) => {
              component.show();

              event.stopPropagation();
              event.preventDefault();
            }
          );

          actions.appendChild(deleteButton);
          resultElement.appendChild(actions);
        }

        groupResults.appendChild(item);

        item.addEventListener(
          "keydown",
          (event) => {
            if (event.key === "ArrowUp") {
              this.focusPreviousResult(item);
              event.preventDefault();
            }
            else if (event.key === "ArrowDown") {
              this.focusNextResult(item);
              event.preventDefault();
            }
            else if (event.key === "Enter") {
              item.firstChild.click();
              event.preventDefault();
            }
          }
        );
      }
    }
  }

  async delete(url) {
    await application.entityStore.delete(url);
  }

  focusFirstResult() {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    results[0].focus();
  }

  focusPreviousResult(item) {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    const index = results.indexOf(item);

    if (index > 0) {
      results[index - 1].focus();
    }
  }

  focusNextResult(item) {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    const index = results.indexOf(item);

    if (index < results.length - 1) {
      results[index + 1].focus();
    }
  }

  enterSearch() {
    this.loadingCount++;

    if (this.loadingCount === 1) {
      this.loading.setStatus(true);
      this.loadingIndicator.setStatus(true);
    }
  }

  leaveSearch() {
    this.loadingCount--;

    if (this.loadingCount === 0) {
      this.loading.setStatus(false);
      this.loadingIndicator.setStatus(false);
    }
  }

  search(query) {
    if (this.abortController)
      this.abortController.abort();

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.clear();

    application.entityStore.getAll()
      .then((data) => {
        const match = data.filter(
          element =>
            element.Current !== null
            && (
              element.Title.toLowerCase().includes(query.toLowerCase())
              || element.Details.toLowerCase().includes(query.toLowerCase())
            )
        );

        this.renderResults(query, match);
      });

    if (query.length > 2) {
      this.enterSearch();

      fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            Query: query
          }),
          signal
        }
      )
        .then(response => response.json())
        .then(data => {
          this.renderResults(query, data);
        })
        .catch(error => { })
        .finally(() => {
          this.leaveSearch();
        });
    }
  }
}

interactivityRegistration.register("SearchComponent", function (element) { return new SearchComponent(element); });
